<template>
  <div style="position: relative">
    <div class="apply">
      <img
        :src="prefixURL + 'mobile/img/mp/apply.png'"
        alt=""
      >
    </div>
    <van-button
      class="btn"
      text="立即成为"
      block
      @click="goToApplyRegister"
    />
  </div>
</template>

<script>
import { applyCondition, getIsCanApplyOrResult } from "@/api/join";
export default {
  data() {
    return {
      shareInfo: {
        name: this.$store.getters.nickname,
        shareType: "3",
      },
      invite: {},
      showPopup: false,
      applyInfo: {}
    };
  },
  methods: {
    goToApplyRegister() {
      if (this.applyInfo.flag == 5 || this.applyInfo.flag == 7) {
        this.$dialog.alert({
          message: "您已是社区店长身份，<br/>请问要进入您的社区店长主页吗",
          confirmButtonText: "确定",
          confirmButtonColor: "#1993FF",
          cancelButtonText: "取消",
          cancelButtonColor: "#1D1D1D",
          showCancelButton: true,
        })
          .then(() => {
            if (this.$store.getters.ambientType == 0) {
              wx.miniProgram.redirectTo({ url: "/community/pages/personCenter/personCenter" });
            } else {
              this.$router.replace({
                path: "/personal",
              });
            }
          });
      }
      if (this.applyInfo.flag == 6) {
        this.$router.replace({
          path: "/applyRegister",
        });
      }
    },
    subtr(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      //动态控制精度长度
      n = r1 >= r2 ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
  },
  mounted() {
    applyCondition({}).then((res) => {
      if (res.appStatus.errorCode == 0) {
        res.content.needInviteNum = this.subtr(
          res.content.leastInviteNum,
          res.content.inviteNum
        );
        this.invite = res.content;
      }
    });
  },
  beforeRouteEnter(to, form, next) {
    getIsCanApplyOrResult({
      communityShopId: "0",
    }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        let applyInfo = res.content.applyInfo;
        applyInfo.flag = res.content.flag;
        applyInfo.failReason = res.content.failReason;
        // applyInfo.flag: "0", 0不能申请 1申请临时社区店长 2申请正式社区店长 3审核中 4审核失败 5已经审核通过 6没有申请 7冻结
        if (applyInfo.flag == 3 || applyInfo.flag == 4) {
          next({
            name: "applySuccess",
            path: "/applySuccess",
            params: {
              info: JSON.stringify(applyInfo),
            },
            replace: true
          });
        }
        next(vm => {
          vm.applyInfo = applyInfo;
        });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.apply {
  width: 100%;
  height: 100%;
  position: relative;
  img {
    width: 100%;
    display: block;
  }
}
.btn {
  width: 180px;
  height: 50px;
  position: fixed;
  left: 98px;
  bottom: 17px;
  font-size: 19px;
  color: #ffffff;
  background-color: #363648;
  border-width: 0 !important;
  border-radius: 10px;
}
</style>